import { makeStyles } from "@material-ui/core/styles";
import { FONTS } from "../../../../emotion-theme";

export const useFlyerListGridCardStyles = makeStyles(() => ({
  card: {
    width: "220px",
    display: "inline-block",
    fontFamily: FONTS.primary,
    minHeight: "200px",
    border: "1px solid transparent",
    textDecoration: "none",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "lighterBlue",
      borderColor: "skyBlue",
    },
  },
}));
